import * as React from 'react';

import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import Lenders from '@lendi-jam/lenders';

import { GenericLendersContent } from '#contentTypes/Lenders';

interface PrismicLendersProps {
  component: GenericLendersContent;
}

const PrismicLenders: React.FC<PrismicLendersProps> = ({ component }) => {
  const LendersContentPrimary = component.primary;

  const LogoItems = component.items ? component.items.map((item) => item.logo) : [];

  return (
    <Lenders
      variant={LendersContentPrimary.toggle_new_version ? 'new' : 'old'}
      subtitle={LendersContentPrimary.subheading ? LendersContentPrimary.subheading.text : ''}
      title={LendersContentPrimary.heading ? LendersContentPrimary.heading.text : ''}
      logos={LogoItems}
      moreLink={{
        text: LendersContentPrimary.more_link ? LendersContentPrimary.more_link.text : '',
        url: embedMarketingTrackingIntoURL(LendersContentPrimary.more_link_url.url),
      }}
      primaryButton={{
        text: LendersContentPrimary.primary_button_text ? LendersContentPrimary.primary_button_text.text : '',
        url: embedMarketingTrackingIntoURL(LendersContentPrimary.primary_button_link.url),
      }}
      secondaryButton={{
        text: LendersContentPrimary.secondary_button_text ? LendersContentPrimary.secondary_button_text.text : '',
        url: embedMarketingTrackingIntoURL(LendersContentPrimary.secondary_button_link.url),
      }}
    />
  );
};

export default PrismicLenders;
